module.exports = __webpack_public_path__ + "img/pulse-outline.0704478b.svg";